import { Box, MenuItem } from '@mui/material';
import { PartnerDomain } from '@provision/entity-types';
import dayjs from 'dayjs';
import {
  MaterialReactTable,
  MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import { useMemo } from 'react';
import { useConfirmationModal } from 'src/utils/hooks';
import { DATE_FORMAT } from './const';

const defaultColumn = {
  enableSorting: false,
  enableColumnActions: false,
};
const tableBackgroundStylingProps = {
  elevation: 0,
};
const columns = [
  {
    accessorKey: 'domain',
    header: 'Domain',
  },
  {
    accessorKey: 'createdAt',
    header: 'Added on',
    Cell: ({ renderedCellValue }: { renderedCellValue: string }) => (
      <Box>{dayjs(renderedCellValue).format(DATE_FORMAT)}</Box>
    ),
  },
];

export const UsersPartnerDomainTable = ({
  domains,
  onDelete,
}: {
  domains: Partial<PartnerDomain>[];
  onDelete: (domainId: string) => void;
}) => {
  const { confirm } = useConfirmationModal();
  const config = useMemo(
    () =>
      ({
        columns,
        enableRowVirtualization: true,
        enableColumnVirtualization: true,
        data: domains,
        defaultColumn,
        enableTopToolbar: false,
        enableBottomToolbar: false,
        enableRowActions: true,
        enablePagination: false,
        muiTablePaperProps: tableBackgroundStylingProps,
        enableStickyHeader: true,
        muiTableHeadCellProps: {
          sx: (theme) => ({
            backgroundColor: theme.palette.custom.OV.sys.surfaceContainerLowest,
          }),
        },
        muiTableContainerProps: {
          sx: {
            margin: '1rem 0',
          },
        },
        initialState: {
          columnPinning: {
            right: ['mrt-row-actions'],
          },
        },
        renderRowActionMenuItems: ({ row, closeMenu }) => {
          const menuItems: React.ReactNode[] = [];

          menuItems.push(
            <MenuItem
              key="enable"
              onClick={async () => {
                closeMenu();
                if (
                  await confirm({
                    title: 'Delete domain?',
                    body: `${row.original.domain ?? 'This domain'} will be deleted permanently.`,
                    confirmLabel: 'Delete domain',
                    danger: true,
                  })
                ) {
                  onDelete(row.original.id!);
                }
              }}
              sx={{ m: 0 }}
            >
              Remove domain
            </MenuItem>,
          );

          return menuItems;
        },
      }) as MRT_TableOptions<Partial<PartnerDomain>>,
    [domains, onDelete, confirm],
  );

  const table = useMaterialReactTable(config);
  return <MaterialReactTable table={table} />;
};
